export const UNTITLED_COLLECTION_TITLE = "Untitled Collection";
export const UNTITLED_CONTACT_TITLE = "Untitled Contact";
export const UNTITLED_NOTE_TITLE = "Untitled Note";
export const UNTITLED_TEMPLATE_TITLE = "Untitled Template";
